import React from 'react';
import { CheckCircle, X, ArrowRight } from 'lucide-react';

const ComparisonSection = ({ onOpenModal }) => {
  const comparisons = [
    { feature: 'Time to hire', without: '3-6 months', with: '72 hours' },
    { feature: 'Vetting process', without: 'You do it yourself', with: 'Pre-vetted top 3%' },
    { feature: 'Risk', without: 'High upfront cost', with: 'Replacement guarantee' },
    { feature: 'Scaling', without: 'Slow & expensive', with: 'Instant & flexible' },
    { feature: 'Quality guarantee', without: 'None', with: '100% satisfaction or replace' },
  ];

  return (
    <section className="bg-[#0a0a0b] py-24 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-red-500/10 border border-red-500/20 text-sm text-red-400 mb-6">
            Stop Wasting Time & Money
          </div>
          <h2 className="text-4xl md:text-5xl text-white font-normal mb-4">
            Hiring is <span className="italic font-light line-through text-gray-500">broken.</span> <span className="text-purple-400">We fixed it.</span>
          </h2>
        </div>

        {/* Comparison Table */}
        <div className="bg-[#1a1a1f] rounded-3xl border border-white/5 overflow-hidden mb-8">
          {/* Header Row */}
          <div className="grid grid-cols-3 border-b border-white/5">
            <div className="p-4 md:p-6"></div>
            <div className="p-4 md:p-6 text-center border-l border-white/5">
              <span className="text-red-400 text-sm font-medium">Traditional Hiring</span>
            </div>
            <div className="p-4 md:p-6 text-center bg-purple-600/10 border-l border-purple-500/20">
              <span className="text-purple-400 text-sm font-medium">With Ruonn</span>
            </div>
          </div>

          {/* Comparison Rows */}
          {comparisons.map((item, index) => (
            <div key={index} className="grid grid-cols-3 border-b border-white/5 last:border-b-0">
              <div className="p-4 md:p-6 text-gray-300 text-sm md:text-base">{item.feature}</div>
              <div className="p-4 md:p-6 text-center border-l border-white/5 flex items-center justify-center gap-2">
                <X className="w-4 h-4 text-red-400 hidden md:block" />
                <span className="text-gray-500 text-sm md:text-base">{item.without}</span>
              </div>
              <div className="p-4 md:p-6 text-center bg-purple-600/5 border-l border-purple-500/20 flex items-center justify-center gap-2">
                <CheckCircle className="w-4 h-4 text-green-400 hidden md:block" />
                <span className="text-white text-sm md:text-base font-medium">{item.with}</span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={onOpenModal}
            className="inline-flex items-center gap-2 bg-[#7c3aed] hover:bg-[#6d28d9] text-white px-8 py-4 rounded-full text-base font-medium transition-all duration-300 hover:scale-105 shadow-lg shadow-purple-500/25"
          >
            Start Hiring Smarter
            <ArrowRight className="w-5 h-5" />
          </button>
          <p className="text-gray-500 text-sm mt-4">No credit card required • Cancel anytime</p>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
